import angular from 'angular';

import { CreateTeamFormAngular } from './CreateTeamForm';

export default angular
  .module('shbdeployer.app.teams', [])

  .component('createTeamForm', CreateTeamFormAngular).name;
